import { selection4th } from 'redevConfig'
const list = (selection4th && selection4th.list) || ''
const selection = list ? require(`redevelopment/input/selection4th/${list.templateName}`) : require('./view/selection.html')
export default {
    base: {
        state: 'input.certification.selection4th',
        config: {
            url: '/selection4th',
            abstract: true,
            template: '<div ui-view></div>',
            title: "发票勾选",
            default:'input.certification.selection4th.list'
        },
    },
    list: {
        state: 'input.certification.selection4th.list',
        config: {
            url: '/list',
            template: selection,
            controller: "selectionCtrl4",
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/selection4th/routers.js